import React from 'react';

import { TableBody, TableComponent, TableCell } from './UnappliedPaymentsTable.styled';
import { TableHead } from '../../Invoices.styled';
import { Text } from 'components/v2/Typography/Text';
import { Payment } from 'screens/Invoices/types/payment';

import {
  formatAmount,
  formatDate,
  formatReason
} from '../UnappliedPayments/UnappliedPayments.utils';

export function UnappliedPaymentsTable({ payments }: { payments: Payment[] }) {
  const rows = payments.map(unappliedPayment => (
    <tr key={unappliedPayment.id}>
      <TableCell>
        <Text tag="span" fontStyle="regular">
          {formatDate(unappliedPayment.date)}
        </Text>
      </TableCell>
      <TableCell>
        <Text tag="span" fontStyle="regular">
          {formatReason(unappliedPayment.reason)}
        </Text>
      </TableCell>
      <TableCell $alignRight={true}>
        <Text tag="span" fontStyle="regular">
          {formatAmount(unappliedPayment.amountCents)}
        </Text>
      </TableCell>
      <TableCell $alignRight={true}>
        <Text tag="span" fontStyle="regular">
          {formatAmount(unappliedPayment.azAppliedAmountCents)}
        </Text>
      </TableCell>
    </tr>
  ));

  return (
    <div>
      <TableComponent>
        <thead>
          <tr>
            {TABLE_HEADERS.map(header => (
              <TableHead key={header.text} $alignRight={header.alignRight}>
                <Text tag="span" fontStyle="medium">
                  {header.text}
                </Text>
              </TableHead>
            ))}
          </tr>
        </thead>

        {<TableBody>{rows}</TableBody>}
      </TableComponent>
    </div>
  );
}

const TABLE_HEADERS = [
  { text: 'Date of Service', alignRight: false },
  { text: 'Reason', alignRight: false },
  { text: 'Amount', alignRight: true },
  { text: 'Applied Amount', alignRight: true }
];
